import {StyleSheet} from 'react-native';

import {roseLightest} from '/theme/color/secondary.color';

export const styles = StyleSheet.create({
  base: {
    color: '#000000',
    fontFamily: 'FiraMono-Regular',
    backgroundColor: roseLightest,
  },
});
